import React from "react";
import { useTheme, makeStyles } from "@material-ui/core/styles";
import ButtonWithSpinner from "../ButtonWithSpinner";

const useStyles = makeStyles((theme) => ({
  actionButton: {
    flexDirection: "row",
    height: "auto",
    minHeight: "24px",
    width: "auto",
    fontSize: "10px",
    padding: "4px 8px",
    borderRadius: "12px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    // Aumenta especificidade para sobrescrever estilos do Material-UI
    "&.MuiButton-root": {
      borderRadius: "12px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    },
    "& .MuiButton-label": {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "4px",
      "& svg": {
        fontSize: "14px",
        marginRight: "1px",
      },
      "& .button-text": {
        fontSize: "9px",
        fontWeight: 600,
        lineHeight: 1.2,
        textTransform: "none",
        whiteSpace: "nowrap",
      },
    },
  },
}));

/**
 * Componente reutilizável para botões de ação em tickets
 * @param {Object} props
 * @param {React.Element} props.icon - Ícone do botão
 * @param {string} props.text - Texto do botão
 * @param {string} props.colorType - Tipo de cor do botão (accept, transfer, resolve, reject, create, spy)
 * @param {boolean} props.loading - Estado de loading
 * @param {function} props.onClick - Função de clique
 * @param {Object} props.style - Estilos adicionais
 * @param {...any} props.otherProps - Outras props para o ButtonWithSpinner
 */
const ActionButton = ({
  icon,
  text,
  colorType = "accept",
  loading = false,
  onClick,
  style = {},
  ...otherProps
}) => {
  const classes = useStyles();
  const theme = useTheme();

  // Mapeamento de cores baseado no tema
  const getBackgroundColor = () => {
    const colorMap = {
      accept: theme.palette.action?.accept || "#4CAF50",
      transfer: theme.palette.action?.transfer || "#9C27B0",
      resolve: theme.palette.action?.resolve || "#FF9800",
      reject: theme.palette.action?.reject || "#F44336",
      create: theme.palette.action?.create || "#2196F3",
      spy: theme.palette.action?.spy || "#607D8B",
    };

    return colorMap[colorType] || colorMap.accept;
  };

  return (
    <ButtonWithSpinner
      style={{
        backgroundColor: getBackgroundColor(),
        color: "#FFF",
        ...style,
      }}
      variant="contained"
      className={classes.actionButton}
      size="small"
      loading={loading}
      onClick={onClick}
      {...otherProps}
    >
      {icon}
      <span className="button-text">{text}</span>
    </ButtonWithSpinner>
  );
};

export default ActionButton;